import { Component, Input, OnInit } from '@angular/core';
import { RegularExpressions } from './../../core/helpers/regular-expressions/regular-expressions';
import { ValidationErrors } from '@angular/forms';

@Component({
    selector: 'app-form-errors',
    templateUrl: './form-errors.component.html',
    styleUrls: ['./form-errors.component.scss'],
    standalone: false
})
export class FormErrorsComponent implements OnInit {
  @Input() errors: ValidationErrors;
  @Input() errorPrefix: string;
  numberPattern = RegularExpressions.ONLY_NUMBERS;
  numberLettersPattern = RegularExpressions.ONLY_NUMBERS_AND_LETTERS;
  onlyLetters = RegularExpressions.ONLY_LETTERS;
  onlyLettersEspecialCharts = RegularExpressions.ONLY_LETTERS_ESPECIAL_CHARTS;
  cellPhone = RegularExpressions.ONLY_NUMBER_CELLPHONE;
  phoneResLength = RegularExpressions.PHONE_RES_LENGTH;
  validateEmail = RegularExpressions.VALIDATE_EMAIL;
  validateAddress = RegularExpressions.VALIDATE_ADDRESS;
  validateExt = RegularExpressions.VALIDATE_EXT;
  caracterValido = RegularExpressions.CARACTER_VALIDO;
  constructor() { }

  ngOnInit() {
  }

  compareRegex(formError: string, regex: string) {
    if (!formError) {
      return;
    }
    return formError.includes(regex);
  }


}
